import { render, staticRenderFns } from "./OrderInfoUpdate.vue?vue&type=template&id=39289839&scoped=true&"
import script from "./OrderInfoUpdate.vue?vue&type=script&lang=js&"
export * from "./OrderInfoUpdate.vue?vue&type=script&lang=js&"
import style0 from "./OrderInfoUpdate.vue?vue&type=style&index=0&id=39289839&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39289839",
  null
  
)

export default component.exports